{
  "contact_info": {
    "email": "b2b@nostra.lt",
    "phone": "+37052162016",
    "phone_display": "+370 5 216 20 16",
    "address": "Sausių k., Sausių g. 44, Trakų raj. LT-21401, Lietuva"
  },
  "social": {
    "facebook": "https://www.facebook.com/",
    "instagram": "https://www.instagram.lt",
    "linkedin": "https://www.linkedin.com/",
    "twitter": "https://twitter.com/"
  },
  "productReviews": {
    "total": 0,
    "averageRating": 0
  },
  "phonePrefix": "",
  "phonePatter": "/^(.*)$/"
}
